module.exports = __webpack_public_path__ + "ca66d3e914793000e7be6e9a38352387.MP3";